import { useState } from "react";
import DynamicChart from "./DynamicChart";
import { renderChartToCanvas, downloadChartPng, copyChartToClipboard } from "../../features/export/chartImageExporter";

// Wraps the inline chat chart with export controls. The exported image is
// drawn fresh from the exact same { data, xKey, yKey, type } already on
// screen — never recomputed — so it always matches what the user sees.
export default function ExportableChart({ data, xKey = "label", yKey = "value", type, title, subtitle, watermark = true, locked = false, onLockedAction }) {

  const [copyStatus, setCopyStatus] = useState(null); // null | "copied" | "error"

  const handleDownload = () => {
    if (locked) {
      onLockedAction?.();
      return;
    }
    const canvas = renderChartToCanvas({ data, xKey, yKey, type, title, subtitle, watermark });
    const safeName = (title || "chart").toLowerCase().replace(/[^a-z0-9]+/g, "_");
    downloadChartPng(canvas, `${safeName}.png`);
  };

  const handleCopy = async () => {
    if (locked) {
      onLockedAction?.();
      return;
    }
    try {
      const canvas = renderChartToCanvas({ data, xKey, yKey, type, title, subtitle, watermark });
      await copyChartToClipboard(canvas);
      setCopyStatus("copied");
    } catch (err) {
      console.error("Copy chart failed:", err);
      setCopyStatus("error");
    } finally {
      setTimeout(() => setCopyStatus(null), 2000);
    }
  };

  return (
    <div className="relative group">

      <div className="absolute top-2 right-2 z-10 flex gap-1.5 opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity">

        <button
          onClick={handleCopy}
          title={locked ? "Create a free account to copy charts" : "Copy chart image"}
          className="w-7 h-7 rounded-lg bg-gray-800/90 hover:bg-gray-700 border border-gray-700 flex items-center justify-center text-xs text-gray-300"
        >
          {locked ? "🔒" : copyStatus === "copied" ? "✓" : copyStatus === "error" ? "!" : "📋"}
        </button>

        <button
          onClick={handleDownload}
          title={locked ? "Create a free account to download charts" : "Download chart as PNG"}
          className="w-7 h-7 rounded-lg bg-gray-800/90 hover:bg-gray-700 border border-gray-700 flex items-center justify-center text-xs text-gray-300"
        >
          {locked ? "🔒" : "⬇"}
        </button>

      </div>

      <DynamicChart data={data} xKey={xKey} yKey={yKey} type={type} />

    </div>
  );
}
